import React, { ReactElement } from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppBottomSheet } from "../../Generic/AppBottomSheet";
import { AppButton } from "../../Generic/AppButton";
import { AppTextButton } from "../../Generic/AppTextButton";

interface Props {
  isOpen: boolean;
  onRequestHelp: () => void;
  onRequestClose: () => void;
}

export function AgencyNotFoundBottomSheet(props: Props): ReactElement {
  const onRequestHelp = React.useCallback(() => {
    props.onRequestClose.call(null);
    props.onRequestHelp.call(null);
  }, [props.onRequestClose, props.onRequestHelp]);

  return (
    <AppBottomSheet
      rounded={true}
      className="AgencyNotFoundBottomSheet"
      title={translate(STRINGS.WE_COULDNT_FIND_YOUR_AGENCY)}
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
    >
      <p>{translate(STRINGS.PLEASE_MAKE_SURE_YOU_HAVE_ENTERED_THE_CODE_CORRECTLY)}.</p>

      <AppButton color="white" variant="outline" onClick={props.onRequestClose}>
        {translate(STRINGS.RETRY).toUpperCase()}
      </AppButton>

      <AppTextButton color="white" onClick={onRequestHelp}>
        {translate(STRINGS.HELP_ME_FIND_MY_AGENCY)}
      </AppTextButton>
    </AppBottomSheet>
  );
}
